import { List, Flex } from "antd";
import Pagamento from "../../../../../Models/Financeiro/Titulo/Pagamento/Pagamento";
import { EnumPagamentoTipo } from "../../../../../Models/Financeiro/Titulo/Pagamento/PagamentoTipo";
import BoletoListItem from "./Boleto/BoletoListItem";
import CreditoListItem from "./Credito/CreditoListItem";
import PixListItem from "./Pix/PixListItem";
import Boleto from "../../../../../Models/Financeiro/Titulo/Pagamento/Boleto";
import Credito from "../../../../../Models/Financeiro/Titulo/Pagamento/Credito";
import Pix from "../../../../../Models/Financeiro/Titulo/Pagamento/Pix";
import { Tag } from "antd";
export interface IPagamentoListItemProps extends React.ComponentProps<typeof List.Item.Meta> {
    data:Pagamento
}

export default function PagamentoListItem({
    data,
    ...props
}:IPagamentoListItemProps) {
    return <List.Item>
        <Flex gap={"middle"} style={{ width : "100%", marginTop : 16 }} align="center" vertical={false}>
            {
                props?.avatar
            }
            {data.codTipo === EnumPagamentoTipo.Boleto && <BoletoListItem {...props} style={{ width : "100%", ...props?.style }} data={data as Boleto} />}
            {data.codTipo === EnumPagamentoTipo.Credito && <CreditoListItem {...props} style={{ width : "100%", ...props?.style }} data={data as Credito} />}
            {data.codTipo === EnumPagamentoTipo.Pix && <PixListItem {...props} style={{ width : "100%", ...props?.style }} data={data as Pix} />}
        </Flex>
    </List.Item>
}